import { useState, useEffect } from 'react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  CardMedia,
  Backdrop,
  Grid,
  Box,
  Button,
  CircularProgress
} from '@mui/material';
import { styled } from '@mui/system';
import QRCode from 'qrcode';
import Avatar3 from 'src/assets/images/users/avatar-3.png';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import arcelikServisLogo from 'src/assets/images/logo.jpg';
import arcelikLogo from 'src/assets/images/arcelikBayiLogo.png';
import bekoLogo from 'src/assets/images/bekoBayiLogo.jpg';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
}));



const StyledQRCode = styled('img')({
  width: '120px',
  height: '120px',
  objectFit: 'contain',
});

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});

const StyledCardContent = styled(CardContent)({
  textAlign: 'center',
});

const StyledCard = styled(Card)({
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
});

const StyledLogo = styled('img')({
  width: '60px',
  height: '40px',
  marginBottom: '10px',
});

function generateQRCode(content) {
  const canvas = document.createElement('canvas');
  QRCode.toCanvas(canvas, content, { width: 100 }, (error) => {
    if (error) {
      console.error('QR kodu oluşturulurken bir hata oluştu:', error);
    }
  });
  return canvas.toDataURL();
}

function EmployeeCard({ EmployeeNr, EmployeeName, EmployeeRole, EmployeeDealerGroup }) {
  const classes = useStyles();

  const [personelAdi, setPersonelAdi] = useState(EmployeeName);
  const [departman, setDepartman] = useState(EmployeeRole);
  const [employeeNo, setEmployeeNo] = useState(EmployeeNr);
  const dealerGroup = EmployeeDealerGroup || "";
  const [avatarEmployee, setAvatarEmployee] = useState(Avatar3);
  const [loading, setLoading] = useState(false);
  const qrKodu = generateQRCode(`${personelAdi}, ${departman}`);

  const handleKartiBas = () => {
    const kartElement = document.getElementById('kart').outerHTML;

    const printWindow = window.open('', '', 'width=600,height=400');
    printWindow.document.write('<html><head><title>Kart Yazdır</title>');
    printWindow.document.write('<style>');
    printWindow.document.write(`
      @media print {
        body * {
          visibility: hidden;
        }
        #kart, #kart * {
          visibility: visible;
        }
        #kart {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          margin: auto;
          padding: 20px;
          box-sizing: border-box;
        }
        .no-print {
          display: none !important; /* Yazdırma sırasında "Kartı Bas" butonunu gizle */
        }
        .StyledLogo {
          max-width: 150px;
          height: auto;
        }
      }
      body {
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: white;
      }
      #kart {
        width: 300px; /* Kart genişliğini ayarla */
        text-align: center;
        border: 1px solid #ccc;
        padding: 10px;
      }
      img {
        max-width: 100%;
        height: auto;
      }
    `);
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(kartElement); // Kartın HTML içeriğini yazdırma penceresine ekle
    printWindow.document.write('</body></html>');
    printWindow.document.close(); // Pencereyi kapat
    printWindow.focus(); // Yazdırma penceresine odaklan
    printWindow.print(); // Yazdırma işlemini başlat
    printWindow.close(); // Yazdırma işleminden sonra pencereyi kapat
  };
  // const handleKartiBas = () => {
  //   // Kartı basmak için özel bir işlem yapabilirsiniz
  //   // Örneğin, yazdırma işlemine yönlendirme veya PDF oluşturma gibi
  //   alert('Kartı basma işlemi gerçekleştirildi!');
  // };

  const GetEmployeeImage = () => {
    setLoading(true);
    axios.get(`GetEmployeeImage/${employeeNo}`).then((response) => {
      if (response.data.length > 0) {
        setAvatarEmployee(response.data[0].Image);
        setLoading(false);
      } else {
        setAvatarEmployee(Avatar3)
        setLoading(false);
      }
    })
  }

  useEffect(() => {

    GetEmployeeImage();
  }, []);


  return (
    <div>
      <Container maxWidth="sm">
        <Grid container justifyContent="center" alignItems="center">
          <StyledCard id="kart"> {/* Kartın ID'si burada önemli */}
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: "center" }}>
              <StyledLogo
                src={dealerGroup === "ARÇELİK" ? arcelikLogo : dealerGroup === "BEKO" ? bekoLogo : arcelikServisLogo}
                alt="Şirket Logosu"
                sx={{ maxHeight: '150px', width: 'auto' }}
                className="StyledLogo"
              />
            </Box>
            <StyledCardMedia
              component="img"
              alt="Personel Fotoğrafı"
              src={avatarEmployee}
            />
            <StyledCardContent>
              <Typography variant="h5" component="div" gutterBottom>
                {personelAdi}
              </Typography>
              <Typography color="text.secondary" gutterBottom>
                {departman}
              </Typography>
              <StyledQRCode src={qrKodu} alt="QR Kodu" />
            </StyledCardContent>
            <Button variant="contained" color="secondary" onClick={handleKartiBas} className="no-print">
              Kartı Bas
            </Button>
          </StyledCard>
        </Grid>
      </Container>
    </div>
  );
}

export default EmployeeCard;
